import { render } from "./PagamentoBoletoPix.vue?vue&type=template&id=bd3828dc"
import script from "./PagamentoBoletoPix.vue?vue&type=script&lang=js"
export * from "./PagamentoBoletoPix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__